import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TrustSchoolRow {
  trust_id: string;
  trust_name: string;
  school_id: string;
  school_name: string;
  total_assessments: number;
  wts_count: number;
  es_count: number;
  gd_count: number;
  teacher_count: number;
  avg_syntactic_maturity: number | null;
  avg_textual_cohesion: number | null;
  avg_lexical_precision: number | null;
}

export function useTrustDashboard(since?: Date | null) {
  return useQuery({
    queryKey: ['trust-dashboard', since?.toISOString() ?? null],
    queryFn: async (): Promise<TrustSchoolRow[]> => {
      const { data, error } = await supabase.rpc('get_trust_dashboard_data', {
        p_since: since ? since.toISOString() : null,
      });
      if (error) throw error;
      return (data ?? []) as TrustSchoolRow[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
